export default __webpack_public_path__ + "static/media/Curvet7.1.0419c369.svg";